import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import { ENTITY } from "../constants";
import { getHotspots } from "../store/actions";

export function useHotspotsData(props) {
  const { propertyId, experienceId, elementId, sortField, sortOrientation, hookEnabled = true } = props;

  const dispatch = useDispatch();
  const timer = useRef(null);

  const fetchHotspots = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      const query = {
        sortField,
        sortOrientation,
      };

      dispatch(getHotspots(propertyId, experienceId, elementId, query));
    }, 300);
  };

  useEffect(() => {
    if (hookEnabled) {
      fetchHotspots();
    }
  }, [propertyId, experienceId, elementId, sortField, sortOrientation, hookEnabled]);

  useEffect(() => {
    if (hookEnabled) {
      const listener = () => fetchHotspots();

      const entities = [ENTITY.HOTSPOT];

      entities.forEach((entity) => document.addEventListener(entity, listener));
      return () => entities.forEach((entity) => document.removeEventListener(entity, listener));
    }
  }, [propertyId, experienceId, elementId, sortField, sortOrientation, hookEnabled]);
}
